import { Controller } from "@hotwired/stimulus"

// Persists the light/dark choice per device. The cookie is read server-side on
// the next request so the class is rendered rather than applied by script.
//
// Carrying the theme across Turbo navigations lives in the inline script in
// the layout head, not here — see the comment there for why: that listener
// has to be armed before this controller's bundle has necessarily loaded.
export default class extends Controller {
  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    const value = isDark ? "dark" : "light"
    document.cookie = `ops_theme=${value}; path=/; max-age=31536000; samesite=lax; secure`
    document.documentElement.dataset.opsTheme = value
  }
}
